import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsListItemCount = function (props) {
    var notificationIndex = props.notificationIndex, documentId = props.documentId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-count", { ref: ref, "notification-index": notificationIndex, "document-id": documentId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentDocumentsListItemCount;
